module.exports = __webpack_public_path__ + "static/media/corporate-services-img81.f9d74456.jpg";